import React from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Controller, useWatch } from "react-hook-form";

const TextEditorSection = ({ control, name, label, maxLength }) => {
  // watch the field value
  const fieldValue = useWatch({ control, name });
  const textLength = (fieldValue?.replace(/<[^>]+>/g, "") || "").length;

  return (
    <div className="mb-4">
      <label className="block font-medium text-gray-700 mb-2">{label}</label>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <SunEditor
            {...field}
            setContents={field.value || ""}
            onChange={(content) => field.onChange(content)}
            height="250px"
            setOptions={{
              defaultStyle: "font-family: Roboto, sans-serif; font-size: 14px;",
              font: ["Roboto", "Arial", "Verdana", "Tahoma", "Times New Roman"],
              buttonList: [
                ["undo", "redo"],
                ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                ["font", "fontSize", "formatBlock"],
                ["fontColor", "hiliteColor", "removeFormat"],
                ["align", "horizontalRule", "list", "table"],
                ["link"],
                ["outdent", "indent"],
                ["fullScreen", "codeView"],
              ],
            }}
          />
        )}
      />
      {maxLength && (
        <p
          className={`text-blue-500 text-sm font-medium mt-1 text-right ${
            textLength > maxLength ? "text-red-500" : "text-gray-500"
          }`}
        >
          {textLength}/{maxLength}
        </p>
      )}
    </div>
  );
};

export default TextEditorSection;
